import { VERIFY_COUPON } from './constant'

export function verifyCouponBilling (coupon, data) {
  return axios.post(VERIFY_COUPON(coupon), data, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          let errorMessage = ''
          data.errors.forEach((error, idx) => {
            if (idx === 0) {
              errorMessage = error.user_message
            } else {
              errorMessage = errorMessage + ',' + error.user_message
            }
          })
          eobj = new Error(errorMessage)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}



// WEBPACK FOOTER //
// ./app/api/billingCoupon/billingCoupon.js